import React, { useContext } from 'react';
import ConfigContext from '../../../contexts/ConfigContext';
import GenericFilter from './GenericFilter';

const LiveViewEmployeeTypeFilter = (props) => {
  const { t } = useContext(ConfigContext);

  const employeeTypeOptions = [
    { value: 'internal', label: t('internalEmployees') },
    { value: 'external', label: t('externalEmployees') }
  ];

  return (
    <GenericFilter {...props} titleKey="employeeType" namePrefix="employeeType" staticOptions={employeeTypeOptions} />
  );
};

export default LiveViewEmployeeTypeFilter;
